module.exports = "/assets/55ed9fe129d37dbe0f9bc2011f6aec6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HQ.png
// module id = 1448
// module chunks = 0